import { useContext } from 'react';
import { useStore } from 'zustand';

import { BaleAnalysisContext } from '../../components/BaleAnalysisContext/BaleAnalysisContext';

export const useBaleAnalysisStore = () => {
  const store = useContext(BaleAnalysisContext);
  if (!store) {
    throw new Error('Missing BaleAnalysisProvider');
  }
  return useStore(store);
};
